import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { isNil, omitBy } from 'lodash-es';
import { useTheme } from '@emotion/react';
import { memo } from 'react';
import Typography from '../../Typography/index.js';
import { Truncated } from '../../Truncated/index.js';
import useEllipsis from '../../useEllipsis/index.js';
const styles = {
    large: {
        fontSize: '2.4rem',
        lineHeight: 1.17,
        letterSpacing: -0.25
    },
    medium: {
        fontSize: '1.8rem',
        lineHeight: 1.22,
        letterSpacing: -0.25
    },
    small: {
        fontSize: '1.6rem',
        lineHeight: 1.25,
        letterSpacing: -0.15
    },
    tiny: {
        fontSize: '1.4rem',
        lineHeight: 'normal',
        letterSpacing: 'normal'
    }
};
const Title = memo(props => {
    const { style, children, maxLines, size = 'medium', truncatedView = 'tooltip', ...restProps } = props;
    const { ref, isTruncated } = useEllipsis(maxLines);
    const theme = useTheme();
    const customStyles = typeof style === 'function' ? style(theme) : style;
    function render(truncatedStyles) {
        return (_jsx(Typography, { ...restProps, ref: ref, style: theme => ({
                fontWeight: 600,
                position: 'relative',
                color: theme.primaryDataColor,
                ...styles[size],
                ...truncatedStyles,
                ...omitBy(customStyles, v => isNil(v) || v === '')
            }), children: children }));
    }
    if (isTruncated) {
        return (_jsx(Truncated, { content: children, view: truncatedView, maxLines: maxLines, children: truncatedStyles => render(truncatedStyles) }));
    }
    return render();
});
export default Title;
//# sourceMappingURL=index.js.map